var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F7B089"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5C24 24.6716 24.6716 24 25.5 24H48C49.6569 24 51 25.3431 51 27V28.5C51 29.3284 50.3284 30 49.5 30H25.5C24.6716 30 24 29.3284 24 28.5V25.5Z",
    fill: "#FF820E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 48H24C22.3431 48 21 46.6569 21 45V27C21 25.3431 22.3431 24 24 24H45C46.6569 24 48 25.3431 48 27V30H21.75",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18H30V24H25.5V18Z",
    fill: "#F7B089"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18H43.5V24H39V18Z",
    fill: "#F7B089"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.25C25.5 19.0074 26.5074 18 27.75 18V18C28.9926 18 30 19.0074 30 20.25V24H25.5V20.25Z",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.25C39 19.0074 40.0074 18 41.25 18V18C42.4926 18 43.5 19.0074 43.5 20.25V24H39V20.25Z",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47.98H34.5",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37.5L48 31.5",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4687 43.9487L49.5026 47.9825L45.4688 52.0164",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 36H25.5",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 40.5H25.5",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36 36H33",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40.5H33",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 36H40.5",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 40.5H40.5",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.4713adc6ce3ef7b25f1c9b3d19075086.svg";
export { ForwardRef as ReactComponent };